import React, { useState, useEffect } from "react";
import { confirm } from "react-confirm-box";

import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { useNavigate } from 'react-router-dom'
import { saveAs } from 'file-saver';
//var dateFormat = require('dateformat');


const RenderIntairbill = () => {


const resturl=sessionStorage.getItem("RESTURL");

const navigate = useNavigate();
const location = useLocation();

window.addEventListener("keypress", function (event) {
 // detect event key
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});

let tableLoaded=false;



const [tblbillitems, setTblbillitems] = useState([]);
const [tblintairbillcalend, setTblintairbillcalend] = useState([]);
const [tblintairbillpage, setTblintairbillpage] = useState([]);
const [tblintairbillyear, setTblintairbillyear] = useState([]);
const [finyrs, setFinyrs] = useState([]);

const [city, setCity] = useState({name:''});

const [dowait, setDowait] = useState({show:false});
const [billitems, setBillitems] = useState({});
const [openbill, setOpenbill] = useState({});//will store all changes to a bill

const [index, setIndex] = useState({i:null});
const [crit, setCrit] = useState({
		billid: 0
		, date1: ""
		, yearname: ""
		, airline: ""
		, month_name: ""
		, file_name: ""
		, str_date: ""
	});

	
	
//const [worksheetitem, setWorksheetitem] = useState({});
const [worksheet, setWorksheet] = useState({WORK_SHEET_ID:'', ITM_NBR:''});


useEffect(() => {
	document.title =   "Airline Overtime";	
	if (sessionStorage.getItem("AD_USER")==null){
	navigate("../logout");
	return;
	}
	
	getfinyrs();
	

},[]);


useEffect(() => {
	
	if (finyrs.length>0)
		gettblintairbillyear();
},[JSON.stringify(finyrs)]);

useEffect(() => {
	if (tblbillitems.length==0){
		let datas=openbill;
			// this should normally be set from db.  But if the bill has no items (is empty) it will not be set.
			const arrFld="SEQNUM,PAGE,DATED,BTIME,PM,REGNUM,ENTRA,CLERA,HRS,RATE,OFFICERS,WAIT,TOTAL".split(",");
			for (var i=0; i<arrFld.length; i++){
				const attributename=arrFld[i];
				datas[attributename] = "";
				}//end for
		setOpenbill(datas);
		}//end if
	
},[JSON.stringify(tblbillitems)]);


useEffect(() => {
if (tblintairbillyear.length>0)
	openCity(null, "airlinemonths");
},[JSON.stringify(tblintairbillyear)]);



useEffect(() => {
	
	if (crit.billid>0){
		gettblbillitems();
		gettblintairbillcalend();
		//gettblintairbillyear();
		}
	else{
		setTblbillitems([]);
		setTblintairbillcalend([]);
		setTblintairbillyear([]);
		
		//if (crit.yearname!="")
			//getbillid();
		}//end else
	
},[crit.billid]);

useEffect(() => {
	
	if (crit.date1==""){
		setTblintairbillpage([]);
		setTblbillitems([]);
		}
		
	else{
		gettblintairbillpage();
		gettblbillitems();
		}
		

	
},[crit.date1]);
	

useEffect(() => {
	
	if (crit.yearname=="")
		setTblintairbillyear([]);
	else
		gettblintairbillyear();
	
},[crit.yearname]);

useEffect(() => {

console.log("JSON.stringify(openbill): "+JSON.stringify(openbill));

},[openbill]);






async function getfinyrs(){
	

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };

 await fetch(resturl+'rarapot/getfinyrs',requestOptions)
      .then(res => res.json())
      .then(res => aftergetfinyrs(res))
      .catch(err => console.log(err));

}//end func

function aftergetfinyrs(res){
let temp=[];
let firstyearname=crit.yearname;
res.map((col, index) => {
	const key="finyrs_"+index;
	const yearname=col['YEARNAME'];
	let selected="";
	//console.log("BILL_DATE "+col['BILL_DATE']);
	if (col['BILL_DATE']!=null){
		firstyearname=yearname;
		selected=" selected ";
		}//end func
		
	
	temp.push(<option key={key+"_cod"} value={yearname} selected={selected} >{yearname}</option>);
	});//end map

setFinyrs(temp);
setCrit((prev)=>{
	return {...prev, yearname:firstyearname}
	});
}//end func

async function getbillid(e, AIRLINEID, YRMM){
	console.log("getbillid "+YRMM);
	e.preventDefault();
	
	let params={
	AIRLINEID: AIRLINEID
	, YRMM:YRMM
			}
		
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

document.getElementById("tblintairbillyear").style.visibility="hidden";

 await fetch(resturl+'rarapot/getbillid',requestOptions)
      .then(res => res.json())
      .then(res => aftergetbillid(res))
      .catch(err => console.log(err));

}//end func

function aftergetbillid(res){

document.getElementById("tblintairbillyear").style.visibility="visible";
	
	console.log("aftergetbillid: "+JSON.stringify(res));
	
	if (res.length)
		if (res.length==1)
			setCrit((prev)=>{
				return {...prev
				, billid:res[0].BILLID
				, date1:res[0].DATE1
				, airline:res[0].AIRLINE
				, month_name:res[0].MONTH_NAME
				, file_name:res[0].FILENAME
				}
			})			
}//end func

function clickReturn(e){
//Tblintairbillyear openCity(e, "airlinemonths");	
e.preventDefault();
cleartblitemsrow1();
gettblintairbillyear();
setCrit((prev)=>{
	return {...prev
				, billid:0
				, date1:""
				, airline:""
				, month_name:""
				, file_name:""
				}
});
}//end func



async function gettblintairbillyear(){

let params={
	yearname: crit.yearname
			}
		
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

setTblintairbillyear([]);

 await fetch(resturl+'rarapot/tblintairbillyear',requestOptions)
      .then(res => res.json())
      .then(res => aftergettblintairbillyear(res))
      .catch(err => console.log(err));
	  
return false;
}//end function

function aftergettblintairbillyear(res){
	

	
if (!res.length)
	return;
let temp=[];
let ARRAY_YRMM=[];
let rownum=1;
res.map((col, index) => {
	const key="tblpages_"+index;
	
	
	const BAND=col['BAND'];
	
	if (BAND=="01"){
		for (var i=4; i<=15; i++){
			const mm=(i>12)?i%12:i;
			
			const colNam=(mm<10)?"AMT0"+mm:"AMT"+mm;
			ARRAY_YRMM.push(col[colNam]);
			}//end for
		
		}
	else if (BAND=="02"){

		if (temp.length==0)
			console.log("ARRAY_YRMM: "+JSON.stringify(ARRAY_YRMM));


	temp.push(	<tr>
				<td align="right" >{rownum}</td>
				<td align="left" >{col['AIRLINE']}</td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[0]);}} >{col['AMT04']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[1]);}} >{col['AMT05']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[2]);}} >{col['AMT06']}</a></td>

				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[3]);}} >{col['AMT07']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[4]);}} >{col['AMT08']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[5]);}} >{col['AMT09']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[6]);}} >{col['AMT10']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[7]);}} >{col['AMT11']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[8]);}} >{col['AMT12']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[9]);}} >{col['AMT01']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[10]);}} >{col['AMT02']}</a></td>
				<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{getbillid(e, col['AIRLINEID'], ARRAY_YRMM[11]);}} >{col['AMT03']}</a></td>
				<td align="right" >{col['TOTAL']}</td>
				</tr>
				);
				rownum+=1;
		}//end else
	});//end map

setTblintairbillyear(temp);

}//end function


function gettblintairbillpage(){

let params={
	billid: crit.billid
	, date1: crit.date1
		}
		
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

  fetch(resturl+'rarapot/tblintairbillpage',requestOptions)
      .then(res => res.json())
      .then(res => aftergettblintairbillpage(res))
      .catch(err => console.log(err));
	  
return false;
}//end function

function aftergettblintairbillpage(res){

if (!res.length)
	return;

let temp=[];
res.map((col, index) => {
	const key="tblpages_"+index;
	
	//console.log("dt: "+col['DAY_TOTAL']);
	
	const DAY_TOTAL=1*col['DAY_TOTAL']==0?"":"$ "+col['DAY_TOTAL'];
	
	if (col['BAND']=='01')
		temp.push(	<tr key={key} >
					<td align="center" >{col['PAGE']}</td>
					<td align="center" >{col['LINES']}</td>
					<td align="center" >{DAY_TOTAL}</td>
					<td align="center" >{"$ "+col['PAGE_TOTAL']}</td>
					</tr>
					);
	else if (col['BAND']=='02'){
		setCrit((prev)=>{
			return {...prev, str_date:col['STR_DATE1']}
		});
		temp.push(	<tr key={key} >
					<td align="center" colSpan="2">{"(Bill Id: "+crit.billid+")\u00A0\u00A0\u00A0Total:"}</td>
					<td align="center" >{"$ "+col['DAY_TOTAL']}</td>
					<td align="center" >{"$ "+col['PAGE_TOTAL']}</td>
					</tr>
					);
		}//end if
	
	});//end map

setTblintairbillpage(temp);

}//end function


function dateChange(e, date1){
	
	e.preventDefault();
	setCrit((prev)=>{
		return {
			...prev
			, date1: date1
			}
		});
	
}//end function

async function gettblintairbillcalend(){

let params={
	billid: crit.billid
		}
		
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };
	
	setTblintairbillcalend([]);
  await fetch(resturl+'rarapot/tblintairbillcalend',requestOptions)
      .then(res => res.json())
      .then(res => aftergettblintairbillcalend(res))
      .catch(err => console.log(err));
	  
return false;
}//end function



function aftergettblintairbillcalend(res){

if (!res.length)
	return;

let temp=[];
res.map((col, index) => {
	const key="tblcalend_"+index;
//	const SUN_DATE=col['SUN_DATE'];
	const WEEK_TOTAL=col['WEEK_TOTAL']?"$ "+col['WEEK_TOTAL']:"";

	if (col['BAND']=='01')
	temp.push(	<tr key={key} >
				<td align="center" ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['SUN']);}} >{col['SUN']?.substring(8,10)}</a></td>
				<td align="center" ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['MON']);}} >{col['MON']?.substring(8,10)}</a></td>
				<td align="center" ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['TUE']);}} >{col['TUE']?.substring(8,10)}</a></td>
				<td align="center" ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['WED']);}} >{col['WED']?.substring(8,10)}</a></td>
				<td align="center" ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['THU']);}} >{col['THU']?.substring(8,10)}</a></td>
				<td align="center" ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['FRI']);}} >{col['FRI']?.substring(8,10)}</a></td>
				<td align="center" ><a href="#" className="nodecor" onClick={(e)=>{dateChange(e, col['SAT']);}} >{col['SAT']?.substring(8,10)}</a></td>
				<td align="center" >{WEEK_TOTAL}</td>
				</tr>
				);
	else if (col['BAND']=='02')
	temp.push(	<tr key={key} >
				<td align="center" ></td>
				<td align="center" ></td>
				<td align="center" ></td>
				<td align="center" ></td>
				<td align="center" ></td>
				<td align="center" ></td>
				<td align="center" >Total:</td>
				<td align="center" >{WEEK_TOTAL}</td>
				</tr>
				);
				});//end map

setTblintairbillcalend(temp);

	
}//end function


function gettblbillitems(){

let params={
	crit: crit
		}

//console.log(JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

setTblbillitems([]);
setDowait({show:true});

  fetch(resturl+'rarapot/tblintairbill',requestOptions)
      .then(res => res.json())
      .then(res => aftertblintairbill(res))
      .catch(err => console.log(err));
	  
return false;
}//end function

function callSetOpenbill(res){
var datas=openbill;

for(var attributename in res){
	//const data=res[0][attributename];
	//datas[attributename] = (data==null)?'':data;
	//console.log("callSetOpenbill attributename: "+attributename);
	datas[attributename] = "";
	}//end for

setOpenbill(datas);	
}//end function

function openrecord(e, i){
	e.preventDefault();
	//console.log("openrecord i: "+i);
	//console.log("openrecord index.i: "+index.i);
	

console.log("openbill: "+JSON.stringify(openbill));
	
	let focused=false;
	for(var attributename in openbill)
		if (attributename!="TOTAL" && attributename!="DATED"){
		const elem=document.getElementsByName(attributename+"[]")[i];
		if (elem){
			elem.readOnly=false;
			elem.required=true;
			if (elem.classList.contains("gnsbro"))
				elem.classList.remove("gnsbro");
			if (elem.value=='' && focused==false){
				elem.focus();
				focused=true;
				}//end if
			}//end if
		
		if (index.i!=null){
			//this is previously selected row.  set it readOnly
			const prevElem=document.getElementsByName(attributename+"[]")[index.i];
			if (prevElem){
				//console.log("prevElem.value: "+prevElem.value);
				prevElem.readOnly=true;
				elem.required=false;
				if (!prevElem.classList.contains("gnsbro"))
					prevElem.classList.add("gnsbro");
				}//end if
			}//end if
		}//end for-if 
		
		if (focused==false && document.getElementsByName("BTIME[]")[i])
			document.getElementsByName("BTIME[]")[i].focus();

		if (document.getElementById("btn_"+i))
			document.getElementById("btn_"+i).style.visibility="visible";

		if (index.i!=null)
			if (document.getElementById("btn_"+index.i))
				document.getElementById("btn_"+index.i).style.visibility="hidden";
		
		let tempindex=index;
		index.i=i;
		setIndex(tempindex);
}//end for

function aftertblintairbill(res){

setDowait({show:false});

openCity(null, "tblbillitems");
let dayNum="";
if (crit.date1)
	if (crit.date1.length==10)
		dayNum=crit.date1.substring(8,10);
	
document.getElementsByName("DATED[]")[0].value=dayNum;
//

let htmrows=[];
		
		
if (!res.length){
	setTblbillitems(htmrows);
	return;
	}
	
if (res.length==0){
	setTblbillitems(htmrows);
	return;
	}//end if
	
if (res.length>0)
	callSetOpenbill(res[0]);
		
		
var rownum=1;

res.map((col, index) => {
	const key='billitems'+index;
	//const celllink='sadlinkid'+index;
	const i=index;
	const itmNbr=index+1;
	
	htmrows.push(<tr key={key} >
		<td align="right" >{itmNbr}<input name="SEQNUM[]" defaultValue={res[i].SEQNUM}  type="hidden"  /></td>
		<td align="center" ><input size="1"	name="PAGE[]" readOnly className="gnsbro" defaultValue={res[i].PAGE} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"right"}} /></td>
		<td align="center" ><input size="1"	name="DATED[]" readOnly className="gnsbro" defaultValue={res[i].DATED} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"center"}} /></td>
		<td align="center" ><input size="2"	name="BTIME[]" readOnly className="gnsbro" defaultValue={res[i].BTIME} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"center"}} /></td>
		<td align="center" ><input size="1"	name="PM[]" readOnly className="gnsbro" defaultValue={res[i].PM} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"center"}} /></td>
		
		<td align="center" >
		<a href="#" onClick={(e)=>{openrecord(e, itmNbr);}} ><img src="img/folderyelsmall.png" border="0" /></a>
		&nbsp;&nbsp;
		<input size="4"	name="REGNUM[]" readOnly className="gnsbro" defaultValue={res[i].REGNUM} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"center"}} />
		</td>
		<td align="center" ><input size="2"	name="ENTRA[]" readOnly className="gnsbro" defaultValue={res[i].ENTRA} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"center"}}  /></td>
		<td align="center" ><input size="2"	name="CLERA[]" readOnly className="gnsbro" defaultValue={res[i].CLERA} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"center"}}  /></td>
		<td align="center" ><input size="2"	name="HRS[]" readOnly className="gnsbro" defaultValue={res[i].HRS} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"center"}}  /></td>
		<td align="center" ><input size="2"	name="RATE[]" readOnly className="gnsbro" defaultValue={res[i].RATE} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"center"}}  /></td>
		<td align="center" ><input size="2"	name="OFFICERS[]" readOnly className="gnsbro" defaultValue={res[i].OFFICERS} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"center"}}  /></td>
		<td align="center" ><input size="2"	name="WAIT[]" readOnly className="gnsbro" defaultValue={res[i].WAIT} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"center"}}  /></td>
		<td align="center" ><input size="2"	name="TOTAL[]" readOnly className="gnsbro" defaultValue={res[i].TOTAL} onChange={(e)=>{worksheetChange(e, itmNbr);}} onFocus={(e)=>{worksheetFocus(e, itmNbr);}} style={{textAlign:"center"}}  /></td>
		<td align="center" ><input type="image" id={"btn_"+itmNbr} style={{visibility:"hidden"}} src="img/floppysm.png" border="0" /></td>
		
		</tr>
	);
	rownum++;
	}//end for
	);

	setTblbillitems(htmrows);
	tableLoaded=true;	
	

}//end function


function cleartblitemsrow1(){
const arrFld="SEQNUM,PAGE,DATED,BTIME,PM,REGNUM,ENTRA,CLERA,HRS,RATE,OFFICERS,WAIT,TOTAL".split(",");	
for (var i=0; i<arrFld.length; i++){
	const fld=arrFld[i]+"[]";
	if (document.getElementsByName(fld)[0])
		document.getElementsByName(fld)[0].value='';
	}//end for
	
}//end function


function worksheetFocus(e, itmNbr){
	e.target.select();
}//end function

function worksheetChange(e, ix){
	
	let {name, value}=e.target;
	
	console.log("worksheetChange ix: "+ix);
	console.log("worksheetChange name: "+name+'->'+value);
	
	//if ((""+name).endsWith("[]"))
	//	name=(""+name).replace("[]", "");
	
//	if (name!="ITM")
	//	value = (""+value).replace(/\D/g,'');
//console.log("openbill: "+JSON.stringify(openbill));
let temp=openbill;
for(var attributename in openbill){
	const elemName=attributename+"[]";
	//console.log("elemName: "+elemName);
	if (document.getElementsByName(elemName)[ix]){
		//const data=res[0][attributename];
		const elemValue =document.getElementsByName(elemName)[ix].value;
		
		if (elemName==name)
			temp[attributename]=value;
		else
			temp[attributename]=elemValue;
		
		}//end if
	}//end for
//console.log("worksheetChange temp: "+JSON.stringify(temp));
setOpenbill(temp);

}//end function


function aftertblintairbillitems(res){
setBillitems(res);
/*
if (res.length==undefined){
	//showsnackbar("no records were returned from the database");
	setWorksheetitem({});
	setTblbillitems([]);	
	return;
	}
else{
	var datas={};

	for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
		}//end for


	setWorksheetitem(datas);
	}
*/

}//end function


async function rptintairbill(e){
	e.preventDefault();

const params={
	USERNAME:sessionStorage.getItem("AD_USER")
	,BILLID:crit.billid
	, FILENAME:crit.file_name
	}

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

document.getElementById("btnpdfbill").style.visibility="hidden";

  await fetch(resturl+'rarapot/rptintairbill',requestOptions)
      .then(res => afterrptintairbill(res))
      .catch(err => console.log(err));
	  
	
}//end function

async function afterrptintairbill(res){
	
	document.getElementById("btnpdfbill").style.visibility="visible";
	
	const pBlob = await res.blob();
//	const json =  await res.json();
//console.log('json '+JSON.stringify(json));
//const data = window.URL.createObjectURL(new Blob([blob]));

/*
const link = document.createElement("a");
link.href = data;
link.setAttribute("download", filename);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	

*/	
	 //saveAs(data.getBlob(), filename);
	var blob = new Blob([pBlob], {type: "application/pdf"});
	//const fileName = res.headers['content-disposition'];
	//console.log('res '+res.fileName);
	//console.log('pBlob '+pBlob);
saveAs(blob, crit.file_name+".pdf");//, "ireportfromdb1234.pdf"
}//end func

function submitform1(e){
	//alert('hey');
	e.preventDefault();
	console.log(JSON.stringify(openbill));
	
	let params=openbill;
	params.USERNAME=sessionStorage.getItem("AD_USER");
	params.BILLID=crit.billid;
	

//console.log(JSON.stringify( params ));

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };



  fetch(resturl+'rarapot/updateintairbill',requestOptions)
      .then(res => res.json())
      .then(res => afterupdateintairbill(res))
      .catch(err => console.log(err));
	  
	
}//end function

function finyrChange(e){
const {name, value}=e.target;
setCrit((prev)=>{
	return {...prev
	, [name]:value
	, billid:0
	, date1:""
	, airline:""
	, month_name:""
				
	}
	});
}//end function

function afterupdateintairbill(res){
	showsnackbar("done!");
	cleartblitemsrow1();
	gettblbillitems();
}//end function

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func

function checkDateEmpty(e){
	if (e.target.value=="")
		showsnackbar("click the date in the calendar to the left");
}//end func

function openCity(evt, cityName) {
	
	if (evt)
		evt.preventDefault();
	
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  if (document.getElementById(cityName))
	document.getElementById(cityName).style.display = "block";

if (evt)
	if (evt.currentTarget)
		evt.currentTarget.className += " active";
	
  setCity({name:cityName});
}//end func

const tblPages=<table align="center" className="customers" border="0" cellSpacing="0" cellPadding="0"  >
 <thead>
 <tr>
 <th>Page</th>
 <th>Lines</th>
 <th>Day Amt</th>
 <th>Total Amt</th>
 </tr>
 </thead>
 <tbody>
 {tblintairbillpage}
 </tbody>
</table>;


const tblCalend=<table align="center" className="customers" border="0" cellSpacing="0" cellPadding="0"  >
 <thead>
 <tr>
 <th>Sun</th>
 <th>Mon</th>
 <th>Tue</th>
 <th>Wed</th>
 <th>Thu</th>
 <th>Fri</th>
 <th>Sat</th>
 <th>Week Total</th>
 </tr>
 </thead>
 <tbody>
 {tblintairbillcalend}
 </tbody>
</table>;

const tblItems= <>
<form id="form1" method="POST" onSubmit={(e)=>{submitform1(e);}}>

<table className="customers" style={{width:"98%", marginBottom:"36px" }}  >
 <thead>
 <tr>
 <th>#</th>
 <th>Pg</th>
 <th>Date</th>
 <th>Time</th>
 <th>PM</th>
 <th>Reg#</th>
 <th>Entr</th>
 <th>Cler</th>
 <th>Hrs</th>
 <th>Rate</th>
 <th>Offcrs</th>
 <th>Wait</th>
 <th>Total</th>
 </tr>
 </thead>
 <tbody>
		<tr key='billitems00' >
		<td align="right" >&nbsp;<input name="SEQNUM[]" value="0" type="hidden" /></td>
		<td align="center" ><input size="1"	name="PAGE[]"  		readOnly className="gnsbro" onChange={(e)=>{worksheetChange(e, 0);}}  style={{textAlign:"right"}} autoComplete="off" /></td>
		<td align="center" ><input size="1"	name="DATED[]"  	readOnly className="gnsbro" onFocus={(e)=>{checkDateEmpty(e);}}  		style={{textAlign:"center"}} autoComplete="off" /></td>
		<td align="center" ><input size="2"	name="BTIME[]"  	readOnly className="gnsbro" onChange={(e)=>{worksheetChange(e, 0);}}  style={{textAlign:"center"}} autoComplete="off" /></td>
		<td align="center" ><input size="1"	name="PM[]"  		readOnly className="gnsbro" onChange={(e)=>{worksheetChange(e, 0);}}  style={{textAlign:"center"}} autoComplete="off" /></td>
		<td align="center" >
		<a href="#" onClick={(e)=>{openrecord(e, 0);}} ><img src="img/folderyelsmall.png" border="0" /></a>
		&nbsp;&nbsp;
		<input size="4"	name="REGNUM[]"  	readOnly className="gnsbro" onChange={(e)=>{worksheetChange(e, 0);}}  style={{textAlign:"center"}} autoComplete="off" />
		</td>
		<td align="center" ><input size="2"	name="ENTRA[]"  	readOnly className="gnsbro" onChange={(e)=>{worksheetChange(e, 0);}}  style={{textAlign:"center"}} autoComplete="off" /></td>
		<td align="center" ><input size="2"	name="CLERA[]"  	readOnly className="gnsbro" onChange={(e)=>{worksheetChange(e, 0);}}  style={{textAlign:"center"}} autoComplete="off" /></td>
		<td align="center" ><input size="2"	name="HRS[]"		readOnly className="gnsbro" onChange={(e)=>{worksheetChange(e, 0);}}  style={{textAlign:"center"}} autoComplete="off" /></td>
		<td align="center" ><input size="2"	name="RATE[]"		readOnly className="gnsbro" onChange={(e)=>{worksheetChange(e, 0);}}  style={{textAlign:"center"}} autoComplete="off" /></td>
		<td align="center" ><input size="2"	name="OFFICERS[]"	readOnly className="gnsbro" onChange={(e)=>{worksheetChange(e, 0);}}  style={{textAlign:"center"}} autoComplete="off" /></td>
		<td align="center" ><input size="2"	name="WAIT[]" 		readOnly className="gnsbro" onChange={(e)=>{worksheetChange(e, 0);}}  style={{textAlign:"center"}} autoComplete="off" /></td>
		<td align="center" ><input size="2"	name="TOTAL[]"		readOnly className="gnsbro" onChange={(e)=>{worksheetChange(e, 0);}}  style={{textAlign:"center"}} autoComplete="off" /></td>
		<input type="image" id={"btn_0"} style={{visibility:"hidden"}} src="img/floppysm.png" border="0" />
		</tr>
		{tblbillitems}
 </tbody>
 </table>
 </form>
 </>;


  return (
    <>

<div align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"22px"}} >Airline Monthly Overtime Bill</div>

<div id="airlinemonths" align="center" className="tabcontent" style={{width:"75%", marginBottom:"12px" }} >
<select name="yearname" onChange={(e)=>{finyrChange(e);}} >
{finyrs}
</select>
<br/>
<table className="customers" id="tblintairbillyear" >
 <thead>
 <tr>
 <th>#</th>
 <th>AIRLINE</th>
 <th>Apr</th>
 <th>May</th>
 <th>Jun</th>
 <th>Jul</th>
 <th>Aug</th>
 <th>Sep</th>
 <th>Oct</th>
 <th>Nov</th>
 <th>Dec</th>
 <th>Jan</th>
 <th>Feb</th>
 <th>Mar</th>
 <th>Total</th>
 </tr>
 </thead>
 <tbody>
  {tblintairbillyear}
 </tbody>
 </table>
</div>
{/*
id="tblbillitems" className="tabcontent" style={{width:"90%", marginBottom:"12px" }}
color:"brown",fontSize:"18px"
*/}
<div align="center" id="tblbillitems" className="tabcontent"  style={{marginBottom:"6px", marginTop:"9px"}} >

<a href="#" className="nodecor" onClick={(e)=>{clickReturn(e);}} ><img src="img/return.png" border="0" /> {crit.str_date+" "+crit.airline}</a>



	<table align="center" border="0" width="100%"  >
	 <tbody>
	 <tr valign="top" >
	 <td align="center">
		{tblCalend}<br/>
		{tblPages}
		<div align="center" style={{marginTop:"18px", marginBottom:"24px"}} >
		{crit.billid>0 && 
		<a href="#" className="nodecor" id="btnpdfbill" onClick={(e)=>{rptintairbill(e);}} ><img src="img/pdf.gif" /> generate pdf bill</a>
		}
		{/*<button  className="button" > save Official Receipt Number </button>}*/}
		</div>
	</td>
	 <td align="center">
		{tblItems}
		{
		dowait.show==true && <div align='center' style={{width:"90%"}} className="waiticon"   ><img src="img/Loading_2.gif" border="0" height="36" /> . . . please wait</div>
		}
		{/*
		dowait.show==false && 
		<div id="tblbillitems" className="tabcontent" style={{width:"90%", marginBottom:"12px" }} >
		
		</div>
		*/}

	 
	 </td>
	 </tr>
	 </tbody>
	</table>

</div>

<div id="snackbar" ></div>

    </>
  );
};
{/*style={{minHeight:"700px"}}*/}
export default RenderIntairbill;